<template>
    <svg :viewBox="`${-radius} ${-radius} ${radius * 2} ${radius * 2}`" xmlns="http://www.w3.org/2000/svg" class="block">
        <defs>
            <clipPath :id="clipId">
                <path v-if="shape" :d="shape" :transform="shapeTransform" />
                <circle v-else :r="radius" />
            </clipPath>
        </defs>
        <g :clip-path="`url(#${clipId})`">
            <rect
                v-if="colors.sky"
                :x="-radius"
                :y="-radius"
                :width="radius * 2"
                :height="radius * 2"
                :fill="colors.sky"
            />
            <g fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path v-if="showGrid" :d="sky.grid" :stroke="colors.lines" stroke-opacity="0.3" stroke-width="1" />
                <path
                    v-if="showConstellations"
                    :d="sky.constellations"
                    :stroke="colors.lines"
                    stroke-opacity="0.85"
                    stroke-width="1.8"
                />
            </g>
            <path :d="sky.stars" :fill="colors.stars" />
            <path
                v-if="shape && showBorder"
                :d="shape"
                :transform="shapeTransform"
                fill="none"
                :stroke="colors.lines"
                :stroke-width="(BORDER_WIDTH * 2) / shapeScale"
            />
            <circle
                v-else-if="showBorder"
                :r="radius"
                fill="none"
                :stroke="colors.lines"
                :stroke-width="BORDER_WIDTH * 2"
            />
        </g>
    </svg>
</template>

<script>
import { computeSky, SKY_RADIUS } from './sky';
import { CUTOUT_SQUARE } from '@/components/Editor/Shared/shapes';

const BORDER_WIDTH = 12;

export default {
    name: 'MapStar',
    props: {
        lat: {
            type: Number,
            required: true,
        },
        lng: {
            type: Number,
            required: true,
        },
        // UTC timestamp in ms
        time: {
            type: Number,
            required: true,
        },
        // { sky, stars, lines }; sky: null keeps the theme artwork visible
        colors: {
            type: Object,
            required: true,
        },
        showConstellations: {
            type: Boolean,
            default: true,
        },
        showGrid: {
            type: Boolean,
            default: true,
        },
        // SHAPE_CUTOUTS path drawn over the sky square; null keeps the classic disc
        shape: {
            type: String,
            default: null,
        },
        showBorder: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return { radius: SKY_RADIUS, clipId: `star-map-clip-${this._uid}`, BORDER_WIDTH };
    },
    computed: {
        // Depends on place, time and shape only, so colour changes never recompute the sky.
        sky() {
            // a shape's corners reach past the horizon circle, so draw stars somewhat below it there
            return computeSky(this.lat, this.lng, this.time, this.shape ? -0.35 : 0);
        },
        shapeScale() {
            return (this.radius * 2) / CUTOUT_SQUARE.size;
        },
        shapeTransform() {
            return `scale(${this.shapeScale}) translate(${-CUTOUT_SQUARE.cx} ${-CUTOUT_SQUARE.cy})`;
        },
    },
};
</script>
